import { isUndefined } from 'lodash';

const isDefined = (o) => !isUndefined(o);

export { isDefined };
